import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout } from 'entities/ExportRouters'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'
import { NewInboxRoutes } from 'pages/settings/pages/inboxes/route/type'

export const NewInboxAccessLayout = observer(() => {
  const { pathname, search } = useLocation()

  return (
    <AccessLayout
      name={EnumAccessPageKeys.create_inbox}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: InboxesPath.root,
        })
      }}
      onAccessSuccess={() => {
        if (!pathname.includes(NewInboxRoutes.newInbox)) {
          uiStore.changeRouteViaVue({
            path: `/${InboxesPath.addInbox.stepsRoot}`,
            query: search,
          })
        }
      }}
    />
  )
})
